import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useIsAuthenticated from '../hooks/useIsAuthenticated'; // Import the useIsAuthenticated hook

const Header = () => {
  const { t, i18n } = useTranslation();
  const isAuthenticated = useIsAuthenticated(); // Use the useIsAuthenticated hook

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <Navbar bg="light" expand="lg" fixed="top">
      <Container>
        <Navbar.Brand as={Link} to="/">
          <img
            src="../logo192.png"
            width="30"
            height="30"
            className="d-inline-block align-top rounded-circle me-2"
            alt="CallGeept.AI Logo"
          />
          CallGeept.AI
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/sign-up">Sign Up</Nav.Link>
            <Nav.Link as={Link} to="/pricing">Pricing</Nav.Link>
            {isAuthenticated && (
              <>
                <Nav.Link as={Link} to="/manage">Manage</Nav.Link>
                <Nav.Link as={Link} to="/profile">Profile</Nav.Link>
              </>
            )}
          </Nav>
          <Nav className="ms-auto">
            {!isAuthenticated && <Nav.Link as={Link} to="/login">Login</Nav.Link>}
            <Nav.Item>
              <Button variant="link" onClick={() => changeLanguage('en')}>
                EN
              </Button>
            </Nav.Item>
            <Nav.Item>
              <Button variant="link" onClick={() => changeLanguage('es')}>
                ES
              </Button>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
